import { education } from '../data/profile';
import './SidePanels.css';

export function SidePanels() {
  return (
    <section className="side-grid" aria-label="Education">
      <article className="side-card" data-reveal>
        <header className="card-head">
          <span className="card-tag">07 / Education</span>
          <h2>Background</h2>
        </header>
        <ul className="edu-list">
          {education.map((item) => (
            <li key={item.detail} className="edu">
              <h3>{item.school}</h3>
              <p>{item.detail}</p>
            </li>
          ))}
        </ul>
      </article>
    </section>
  );
}
